import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiService } from '../../shared/services/api.service';
import { Urls } from '../../utils/urls';
import { CommonDataService } from '../../shared/services/common-data.service';
import { GrowthMenuComponent } from './growth-menu/growth-menu.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import value from '*.json';
import {environment} from '../../../environments/environment.prod'
@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {
  fundParams = {
    investmentHorizon : [],
    investmentHorizonSelectionMap: {},
    investmentPurpose : [],
    investmentPurposeSelectionMap: {},
    risk : [],
    riskSelectionMap: {},
    plan : 'Direct Plan - Growth Option'
  };
  activeTab = 'all';
  debtCount = 0;
  equityCount = 0;
  hyBridCount = 0;
  otherCount = 0;
  fundsData = [];
  viewFilters = false;
  schemeType = [
    {
      displayName: 'Direct Scheme',
      value: 'Direct Plan - Growth Option'
    },
    {
      displayName: 'Regular Scheme',
      value: 'Regular Plan - Growth Option'
    },
  ];
  filtersData = [
    {
      heading: 'Investment Risks',
      name: 'risk',
      datas: [
        {
          displayName: 'Very High risks',
          value: 'Very High'
        },
        {
          displayName: 'High risks',
          value: 'High'
        },
        {
          displayName: 'Moderately High risks',
          value: 'Moderately High'
        },
        {
          displayName: 'Moderate risks',
          value: 'Moderate'
        },
        {
          displayName: 'Low to Moderate risks',
          //value: 'Moderately Low'
          value: 'Low to Moderate'
        },
        {
          displayName: 'Low risks',
          value: 'Low'
        }

      ]
    },
    {
      heading: 'Investment Horizon',
      name: 'investmentHorizon',
      datas: [
        {
          displayName: 'Short Term',
          value: 'Short Term'
        },
        {
          displayName: 'Medium Term',
          value: 'Medium Term'
        },
        {
          displayName: 'Long Term',
          value: 'Long Term'
        }

      ]
    },
    {
      heading: 'Investment Purpose',
      name: 'investmentPurpose',
      datas: [
        {
          displayName: 'Tax Saving',
          value: 'Tax Saving'
        },
        {
          displayName: 'Wealth Creation',
          value: 'Long Term Wealth Creation'
        },
        {
          displayName: 'Lowest in Equity segment',
          value: 'Lowest risk product in Equity segment'
        },
        {
          displayName: 'Short Term Parking',
          value: 'Short Term Parking'
        },
        {
          displayName: 'Lowest risk fund',
          value: 'Lowest risk fund'
        }

      ]
    }
  ];

  tabsList = [
    {
      displayName: 'All Funds',
      value: 'all'
    },
    {
      displayName: 'Equity Funds',
      value: 'equity'
    },
    {
      displayName: 'Debt Funds',
      value: 'debt'
    },
    {
      displayName: 'Hybrid Funds',
      value: 'hybrid'
    },
    {
      displayName: 'Others',
      value: 'other'
    }
  ];
  constructor(public route: ActivatedRoute,
              public router: Router,
              private modalService: NgbModal,
              private apiService: ApiService,
              public commonDataService: CommonDataService) {

  }

  ngOnInit() {
    this.scrollTop();
    this.getFunds();
  }
  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  getFunds = () => {
    this.apiService.postData(Urls.getTop3Funds, this.fundParams).subscribe(
      (response) => {
        this.fundsData = response.data.returnValue;
        this.getFundCounts(response.data.returnValue);
      },
      (error) => {
        this.fundsData = [];
      }
    )
    this.viewFilters = false;
  }

  getFundCounts = (data) => {
    this.debtCount = 0;
    this.equityCount = 0;
    this.hyBridCount = 0;
    this.otherCount = 0;
    for ( const item of data ) {
      if (item.fundType === 'Debt') {
        this.debtCount++;
      } else if (item.fundType === 'Equity') {
       this.equityCount++;
      } else if (item.fundType === 'Hybrid') {
       this.hyBridCount++;
      } else {
        this.otherCount++;
      }
     }
  }

  setPlan = (val) => {
    this.fundParams.plan = val;
    this.getFunds();
  }

  splitString = (val) => {
    const str1 = val.split('-')[0].split(' ')[0];
    const str2 = val.split('-')[1].split(' ')[1];
    return str1 + ' - ' + str2;

  }

  setActive = (val) => {
    this.activeTab = val;
  }

  viewDetails = (schemename : string, schemedetails: any) => {
    let url = schemename.replace(/\s/g , "-");
    this.router.navigateByUrl('products/' + url.toLowerCase()); 
  }

  investOnline = () => {
    if(!environment.isDRBuild){
      window.open("https://investonline.itiamc.com/", "_blank");
    }else{
      window.open("https://drinvestor.itiamc.com/", "_blank"); //DR-inv
    }
  }

  applyFilters = (evt, name, val) => {
    if (evt.target.checked) {
      this.fundParams[name].push(val);
    } else {
      const index = this.fundParams[name].indexOf(val);
      this.fundParams[name].splice(index, 1);
    }
    this.getFunds();
  }

  setMobileFilterOptionsFilters = (evt, name, val) => {
    const selectionKey = `${name}SelectionMap`;
    if (evt.target.checked) {
      this.fundParams[name].push(val);
      if( this.fundParams[selectionKey]){
        this.fundParams[selectionKey][val] = val;
      }
    } else {
      const index = this.fundParams[name].indexOf(val);
      this.fundParams[name].splice(index, 1);
      if( this.fundParams[selectionKey]){
        delete this.fundParams[selectionKey][val];
      }
    }
  }

  clearMobileFilters = () => {
    this.fundParams.investmentHorizon =   [];
    this.fundParams.investmentPurpose =   [];
    this.fundParams.investmentHorizonSelectionMap ={};
    this.fundParams.investmentPurposeSelectionMap ={};
    this.fundParams.risk =   [];
    this.fundParams.riskSelectionMap ={};
    this.viewFilters = false;
    this.getFunds();
  }

  setFilterSection = (val) => {
    this.viewFilters = val;

  }

  openPopUpScheme = () => {
      const modalRef = this.modalService.open(GrowthMenuComponent, {  size: 'sm', windowClass: 'align-modal-scheme', backdrop : false, });
      modalRef.componentInstance.valueScheme = this.fundParams.plan;
      modalRef.componentInstance.passEntry.subscribe((data) => {
        this.fundParams.plan = data;
        this.getFunds();
      });
}

}
